function Chapter(data) {
  var self = this;

  self.id = '';
  self.name = '';
  self.topics = ko.observableArray([]);
  self.handbookId = '';
  self.entityType = '';

  if (!!data) {
    self.id = data.id;
    self.name = data.name;
    self.entityType = data.entityType;

    if (!!data.topics) {
      var mappedChildren = $.map(data.topics, function (item) { return new ChildEntity(item); });
      var filteredChildren = ko.utils.arrayFilter(mappedChildren, function (item) {
        return item.subTopics().length > 0 || item.questions().length > 0;
      });
      self.topics(filteredChildren);
    }

    self.handbookId = data.handbookId;
  }
}

function ChildEntity(data) {
  var self = this;

  self.id = '';
  self.name = '';
  self.parentId = '';
  self.parentName = '';
  self.entityType = ''
  self.tileHelpText = '';
  self.topicTileSearchName = '';
  self.subTopics = ko.observableArray([]);
  self.questions = ko.observableArray([]);

  if (!!data) {
    self.id = data.id;
    self.name = data.name;
    self.entityType = data.entityType;
    self.parentId = data.parentId;
    self.parentName = data.parentName;

    if (self.entityType == 'Topic') {
      self.topicTileSearchName = data.topicTileSearchName;
      self.tileHelpText = data.tileHelpText;

      if (!!data.subTopics) {
        var mappedChildren = $.map(data.subTopics, function (item) { return new ChildEntity(item); });
        var filteredChildren = ko.utils.arrayFilter(mappedChildren, function (item) {
          return item.subTopics().length > 0 || item.questions().length > 0;
        });
        self.subTopics(filteredChildren);
      }

    }

    if (!!data.questions) {
      var mappedChildren = $.map(data.questions, function (item) { return new QuestionEntity(item, data.id); });
      self.questions(mappedChildren);
    }


  }
  self.SelectedSubTopics = ko.computed(function () {
    var selectedSubTopics = [];
    if (!!self.subTopics() && self.subTopics().length > 0) {
      selectedSubTopics = ko.utils.arrayFilter(self.subTopics(), function (item) {
        return item.Selected();
      });
    }

    return selectedSubTopics;
  });
  self.SelectedQuestions = ko.computed(function () {
    var selectedQuestions = [];
    if (!!self.questions() && self.questions().length > 0) {
      selectedQuestions = ko.utils.arrayFilter(self.questions(), function (item) {
        return item.Selected();
      });
    }

    return selectedQuestions;
  });
  //To Do Change to Pure Computed based on Question Entity Selected.
  self.Selected = ko.pureComputed({
    read: function () {
      return self.SelectedQuestions().length > 0 || self.SelectedSubTopics().length > 0;
    },
    write: function (value) {
      ko.utils.arrayForEach(self.subTopics(), function (item) {
        item.Selected(value);
      });

      ko.utils.arrayForEach(self.questions(), function (item) {
        item.Selected(value);
      });
    },
    owner: this
  });
}

function QuestionEntity(data, parentId) {
  var self = this;

  self.id = '';
  self.question = '';
  self.answer = '';
  self.entityType = 'QuestionEntity';
  self.parentId = parentId;

  if (!!data) {
    self.id = data.id;
    self.question = data.question;
    self.answer = data.answer;
  }

  self.Selected = ko.observable(false);
}

function HandbookSearchResults(data) {
  var self = this;

  self.searchResults = ko.observableArray([]);
  self.searchFilters = null;
  self.resultCount = ko.observable(0);
  self.hasMoreResults = ko.observable(false);

  if (!!data) {
    self.resultCount(data.resultCount);
    self.hasMoreResults(data.hasMoreResults);
    self.searchFilters = new HandbookSearchFilters(data.searchFilters);

    if (!!data.searchResults) {
      var results = $.map(data.searchResults, function (item) { return new SearchResultEntity(item); });
      self.searchResults(results);
    }

  }

}

function HandbookSearchFilters(data) {
  var self = this;

  self.query = ko.observable('');
  self.skip = ko.observable(0);
  self.handbookId = '';
  self.take = 10;

  if (!!data) {
    self.query(data.query);
    self.skip(data.skip);
    self.handbookId = data.handbookId;
    self.take = data.take;

  }
}

function SearchResultEntity(data) {
  var self = this;

  self.id = '';
  self.title = '';
  self.url = '';
  self.breadcrumbs = [];

  if (!!data) {
    self.id = data.id;
    self.title = data.title;
    self.url = data.url;

    if (!!data.breadcrumbs) {
      var results = $.map(data.breadcrumbs, function (item) { return new BreadcrumbEntity(item); });
      self.breadcrumbs = results;
    }
  }
}

function BreadcrumbEntity(data) {
  var self = this;

  self.id = '';
  self.title = '';
  self.url = '';

  if (!!data) {
    self.id = data.id;
    self.title = data.title;
    self.url = data.url;
  }
}
